import { Link as RouterLink } from "react-router-dom";
import {
  Link,
} from "@mui/material";

export default function EmptyPage() {
  return  (<><h1 
            style={{ 
              textAlign: "center",
              marginTop: "50px" }}
          >
          Not a Valid Page
          </h1>
          <h4
            style={{ 
              textAlign: "center",
              marginTop: "50px" }}
          ><Link component={RouterLink} to="/" color="primary" underline="none" style={{ 
              textAlign: "center",
              marginTop: "20px" }}>
            Back to homepage
          </Link></h4></>);
}
